// extracted by mini-css-extract-plugin
export var rateTable = "_58-0";